<template>
  <router-link :to="/tournaments/ + tournament.tournamentId" class="card">
    <div class="card-header">{{ tournament.name }} </div>
    <div class="card-details">
      <div>editie: {{ tournament.edition }}</div>
      <div>locatie: {{ tournament.location }}</div>
      <div>periode: {{ _startDate }} - {{ _endDate }}</div>
    </div>
  </router-link>
</template>

<script>
//import TimeControl from "@/components/tournaments/TimeControl";
import moment from 'moment';

export default {
  name: 'TournamentCard',
  //components: {TimeControl},
  props: {
    tournament: {
      type: Object,
      required: true
    }
  },
  computed: {
    _endDate: {
      get(){
        if (this.tournament.endDate != null)
          return moment(this.tournament.endDate).format('DD-MM-YYYY')
        else return '';
      }
      },
      _startDate: {
        get(){
        if (this.tournament.endDate != null)
          return moment(this.tournament.startDate).format('DD-MM-YYYY');
        else return '';
       }
      }
  }
}
</script>

<style scoped>

</style>
